<script>
import { Cell, Col, Row, Image, Empty, Tag, IndexBar, IndexAnchor } from 'vant'
import ObjectFunc from '@/tbs/util/ObjectFunc'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'organization-staff-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-image': Image,
        'van-empty': Empty,
        'van-tag': Tag,
        'van-index-bar': IndexBar,
        'van-index-anchor': IndexAnchor,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        staffList: Array,
        staffEmptyHint: String,
        staffInviteLabel: String,
        isRoleNameShow: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['click-item', 'create-item', 'invite-staff'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        isStaffListEmtpy() {
            return this.staffList && ((this.staffList.length == 0) || ObjectFunc.isEmpty(this.staffList))
        },
        staffIndexedList() {
            return this.staffList
        },
        indexList() {
            if (!this.staffList) {
                return []
            }
            const letters = this.staffList.map(staff => staff.firstLetter)
            const uniqueLetters = [...new Set(letters)]
            uniqueLetters.sort()
            // console.log('@uniqueLetters', uniqueLetters)
            return uniqueLetters
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onStaffItemClick(item) {
            this.$emit('click-item', item)
        },
        onStaffEmptyHintClick() {
            this.$emit('create-item')
        },
        onInviteTagClick(item) {
            this.$emit('invite-staff', item)
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        checkNotLogon(item) {
            console.log('checkNotLogon', item.isLogon)
            return !item.isLogon
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="organization-staff-list">
        <div v-if="!isStaffListEmtpy">
            <van-index-bar :index-list="indexList">
                <van-index-anchor 
                    v-for="index in indexList" 
                    :key="index" 
                    :index="index"
                >
                    <van-cell 
                        v-for="item in staffList.filter(staff => staff.firstLetter === index)" 
                        :key="item.id" 
                        center
                        is-link
                        @click="onStaffItemClick(item)"
                    >
                        <template #title>
                            <van-row>
                                <van-col>
                                    <van-image
                                        v-if="item.logoUrl"
                                        :src="adjustImageSize(item.logoUrl, 100, 100)"
                                        fit="cover"
                                        width="50px"
                                        height="50px"
                                    />
                                    <img
                                        v-else
                                        src="@/assets/org/logo-symbol.png" 
                                        style="width: 50px; height: 50px;"
                                    />
                                </van-col>
                                <van-col class="l-outer-margin">
                                    <div>
                                        <span>{{ item.name }}</span>
                                    </div>
                                    <div>
                                        <!--<span v-if="item.isSuperAdmin"><van-tag>{{ item.roleLabel }}</van-tag></span>-->
                                        <span v-if="isRoleNameShow"><van-tag>{{ item.roleLabel }}</van-tag></span>
                                        <span 
                                            v-if="checkNotLogon(item)" 
                                            class="invite-tag"
                                            @click.stop="onInviteTagClick(item)">
                                            <van-tag round plain>{{ staffInviteLabel }}</van-tag>
                                        </span>
                                    </div>
                                </van-col>
                            </van-row>
                            <div class="separator-line-bottom"/>
                        </template>
                    </van-cell>
                </van-index-anchor>
            </van-index-bar>
        </div>
        <div v-else @click="onStaffEmptyHintClick">
            <van-empty 
                :description="staffEmptyHint"
                image="search"
            />
        </div>
    </div>
</template>

<style>
.organization-staff-list .van-index-anchor {
    padding: 0;
}
.invite-tag {
    position: absolute;
    right: 40px;
}
</style>